import { render, staticRenderFns } from "./CommentRecursive.vue?vue&type=template&id=0f294c97&scoped=true&"
import script from "./CommentRecursive.vue?vue&type=script&lang=ts&"
export * from "./CommentRecursive.vue?vue&type=script&lang=ts&"
import style0 from "./CommentRecursive.vue?vue&type=style&index=0&id=0f294c97&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f294c97",
  null
  
)

export default component.exports